import React, { useContext, useEffect } from 'react';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import { estadoCivil, sexo } from '../../data/mochaData';
import useToken from '../../hooks/useToken';
import CustomSelect from '../controls/CustomSelect';
import DateControl from '../controls/DateControl';
import Input from '../controls/Input';
import InputFile from '../controls/InputFile';
import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';
import moment from 'moment';
import BirthDateControl from '../controls/BirthDateControl';

const Step3 = ({ ...rest }) => {



    const { poliza, setPoliza, polizaChangeHandler } = useContext(CotizadorCRDataContext);

    const { file } = poliza;

    const onChangeFiles = (id, newFile) => {

        const { file } = poliza;

        if (id === "file0")
            file[0] = newFile

        if (id === "file1")
            file[1] = newFile

        if (id === "file2")
            file[2] = newFile

        setPoliza({ ...poliza, file });

    }


    const onChangeMunicipio = e => {
        setPoliza({ ...poliza, departamento: e.target.value, municipio: '' });
    }

    const onChangeVigencia = date => {
        let end = moment(date,'DDMMYYYY').add(1,'year').add(-1,'day');

        setPoliza({
            ...poliza, 
            fdesdeIdentificacion: date,
            fhastaIdentificacion:end.toDate(),
        })
    }



    const getMinDate=()=>{
        let end = moment();
        return end.toDate();
    }

    const getMaxDate = () => {
        let end = moment().add(15,'day');
       return end.toDate();
    }

    const getCurrentPlanConfig=()=>{
        return poliza.planesConfig.find(x=>x.id==poliza.planId);
    }

    return (
        <div className="reponsive">
            <div className="reponsive-width-12 box-pl5-pr5 lfheader">
                <label>Datos personales</label>
            </div>
            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">
                    {/* <InputFile id="file2" label='Selfie*' className='btn-sg-primary' handlerFiles={onChangeFiles} file={file[2]} placeholder='Tomar foto' /> */}
                    <InputSelect field='nacionalidad' label='Nacionalidad' value={poliza.nacionalidad} onChange={polizaChangeHandler} dataProvider='nacionalidad' />
                    <CustomSelect label='Sexo' field='sexo' value={poliza.sexo} catalog={sexo} onChange={polizaChangeHandler} />
                    <BirthDateControl label='Fecha de nacimiento' value={poliza.fechaNacimiento} onChange={date => setPoliza({ ...poliza, fechaNacimiento: date })}/>
                    <InputSelect label='Profesión' containBlank={true} value={poliza.profesion} field='profesion' dataProvider='profesion' onChange={polizaChangeHandler} />
                    <InputFile id="file0" label='Documento de identificación frontal' handlerFiles={onChangeFiles} file={file[0]} part='frontal' />
                    <InputFile id="file1" label='Documento de identificación trasera' handlerFiles={onChangeFiles} file={file[1]} part='trasera' />
                    <DateControl label='Fecha de inicio de vigencia' value={poliza.fdesdeIdentificacion} onChange={onChangeVigencia} minDate={getMinDate()} maxDate={getMaxDate()} />
                    <DateControl label='Fecha de vencimiento de vigencia' value={poliza.fhastaIdentificacion} readOnly={true} />
                </div>
            </div>
            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">
                    <SwitchButton label="Posee casa propia" value={poliza.hasHouse} onClick={value => setPoliza({ ...poliza, hasHouse: value })} />
                    <SwitchButton label="Tiene hijos" value={poliza.hasChildren} onClick={value => setPoliza({ ...poliza, hasChildren: value })} />
                    <CustomSelect label='Estado Civil' field='estadoCivil' value={poliza.estadoCivil} catalog={estadoCivil} onChange={polizaChangeHandler} />
                    <Input label='Dirección' field='direccion' value={poliza.direccion} onChange={polizaChangeHandler} />
                    <Input label='Teléfono' pattern='\d\d\d\d-\d\d\d\d' title='Teléfono inválido' type='maskInput' mask='9999-9999' field='telefonoCasa' placeholder='0000-0000' value={poliza.telefonoCasa} onChange={polizaChangeHandler} classNameContainer='w45' classNameInput='w100' />
                    <InputSelect label='País' value={poliza.pais} field='pais' dataProvider='paises' onChange={polizaChangeHandler} />
                    <InputSelect label='Provincia' containBlank={true} value={poliza.departamento} field='departamento' dataProvider={`paises/${poliza.pais}/departamentos`} onChange={onChangeMunicipio} />
                    <InputSelect label='Canton' containBlank={true} value={poliza.ciudad} field='ciudad' dataProvider={`paises/${poliza.pais}/departamentos/${poliza.departamento??0}/ciudades`} onChange={polizaChangeHandler} />
                    <InputSelect label='Distrito' containBlank={true} value={poliza.municipio} field='municipio' dataProvider={`paises/${poliza.pais}/departamentos/${poliza.departamento??0}/ciudades/${poliza.ciudad??0}/distritos`} onChange={polizaChangeHandler} />
                    
                    {/* <SwitchButton label="Posee vehiculo propio" value={poliza.hasCar} onClick={value => setPoliza({ ...poliza, hasCar: value })} /> */}
                </div>
            </div>
        </div>
    );
}

export default Step3;
